import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { Page } from "src/app/util/page";

@Injectable()
export class AuthorService {
  constructor(private httpClient: HttpClient) { }

  public findByNameLike(name: string): Observable<Page<string>> {
    return this.httpClient.get<Page<string>>("/api/author?size=50&name=" + name);
  }
}